import React from 'react'
import classNames from 'classnames'

interface SectionProps {
    title?: string
    children: React.ReactNode
    className?: string
}

export const Section = ({ title, children, className }: SectionProps) => (
    <div className={classNames('section', className)}>
        {title && <div className="section-title">{title}</div>}
        {children}
    </div>
)
